<div id="windy" (mousemove)="this.mapMouseMove($event)">
</div>

<!-- <style>
  #windy #bottom,
  #windy #mobile-ovr-select,
  #windy #embed-zoom {
      display: none !important;
  }

  #windy #logo-wrapper {
      top: initial;
      bottom: 40px;
  }

  #windy #logo-wrapper #logo {
      left: 50px;
  }
</style> -->

<!-- Loghi cliente e SGS tracking -->
<!-- <div *ngIf="this.isScreenLarge">
  <a href="{{this.api.event.website}}" target="_blank" style="position:absolute;top:12px;right:10px;width:120px;">
  <img src="assets/images/234-logo.png" alt="Rolex Giraglia 2019">
</a>
</div> -->

<div *ngIf="!this.isScreenLarge">
  <!-- <a href="{{this.api.event.website}}" target="_blank" style="position:absolute;top:12px;right:10px;width:60px;"> -->
  <a href="{{this.api.event.website}}" target="_blank" style="position:absolute;top:10px;right:10px;width:90px;">
  <!-- <img src="assets/images/234-logo.png" alt="Rolex Giraglia 2019" style="position:absolute;top:0px;right:0px;width:90px;"> -->
  <img src="assets/images/{{this.api.id_event}}-logo.png" alt="{{this.api.event.name}}" style="position:absolute;top:0px;right:0px;width:90px;">
</a>
</div>
<div *ngIf="this.isScreenLarge">
  <a href="{{this.api.event.website}}" target="_blank" style="position:absolute;top:10px;right:10px;width:120px;">
  <!-- <img id="customerlogoLarge"  src="assets/images/234-logo.png" style="position:absolute;top:0px;right:0px;width:120px;" alt="Rolex Giraglia 2019"> -->
  <img id="customerlogoLarge"  src="assets/images/{{this.api.id_event}}-logo.png" style="position:absolute;top:0px;right:0px;width:120px;" alt="{{this.api.event.name}}">
</a>
</div>

<div *ngIf="this.isScreenLarge">
  <a href="http://www.sgstracking.com" target="_blank">  
  <img src="assets/images/sgs-logo5.png" alt="SGS tracking" style="position:absolute;top:12px;right:50%;width:112px;">
  </a>
</div>

<div>
  <a href="http://www.sgstracking.com" target="_blank" style="position:absolute;bottom:64px;right:10px;width:112px;">  
  <img src="assets/images/sgs-logo5.png" alt="SGS tracking" style="position:absolute;bottom:0px;right:0px;width:112px;">
  </a>
</div>


<!-- Pannello imbarcazioni / leaderboard -->
<app-boats></app-boats>

<!-- Pannello gestione playback o ultima data aggiornamento -->

<div id="playback" cdkDrag>
  <!-- Playback -->
  <div *ngIf="this.api.playbackEnabled" style="position:absolute;top:6px;left:6px;">
    <strong>Playback</strong>: {{this.api.playbackDateTime}} 
  </div>
  <div *ngIf="this.api.playbackEnabled" style="font-size:24px;position:absolute;top:0px;left:165px;cursor:pointer;text-align:center">
    <span style="font-size:18px" (click)="this.api.playbackSpeedChange()">{{this.api.playbackSpeed}}x</span>
  </div>  
  <div *ngIf="this.api.playbackEnabled" style="font-size:24px;position:absolute;top:4px;left:192px;">  
    <mat-icon [inline]="true" style="cursor:pointer" (click)="this.api.playbackPlay()">play_arrow</mat-icon>
    <mat-icon [inline]="true" style="cursor:pointer" (click)="this.api.playbackPause()">pause</mat-icon>
    <mat-icon [inline]="true" style="cursor:pointer" (click)="this.api.playbackRestart()" style="cursor:pointer">loop</mat-icon>
  </div>  
    <div style="font-size:24px;cursor:pointer;top:20px;" >
    </div>

  <div *ngIf="this.api.playbackEnabled" style="position:absolute;top:28px;left:165px;">
    <!-- <mat-slider min="1" max="100" step="1" value="50"></mat-slider> -->
    <!-- <mat-slider
    tickInterval="1000"
    min="1"
    value="5000"
    max="10000">
    </mat-slider>     -->
    <input id="playbackRange" type="range" 
      min="{{this.api.trackingBeginEpoch}}" 
      max="{{this.api.trackingEndEpoch}}" 
      value="{{this.api.playbackEpoch}}" 
      (input)="playbackRangeInputChange($event);"
      class="slider" >
    <!-- <input id="playBackRange" type="range" 
      min="{{this.api.trackingBeginEpoch}}" 
      max="{{this.api.trackingEndEpoch}}" 
      value="this.playBackEpochInterval" 
      input="playBackRangeInput(e)"      
      class="slider" > -->


      <!-- this.trackingBeginEpoch = moment(this.event.tracking_begin).unix();
    this.trackingEndEpoch = moment(this.event.tracking_end).unix();
    this.trackingInterval = this.event.trackinginterval; -->

  </div>


  <!-- Live update -->
  <div *ngIf="!this.api.playbackEnabled" style="position:absolute;top:6px;left:6px;"><strong>Live update</strong>: {{this.api.lastUpdateDateTimeString}} </div>
  
  <!-- Handle per drag -->
  <div id="playback-handle" cdkDragHandle>
    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg> 
  </div>    
  
  <div *ngIf="this.api.mapMouseLat>0" style="position:absolute;top:24px;left:6px;">Lat: {{this.api.mapMouseLat|number : '1.4-4'}} / Lon: {{this.api.mapMouseLon|number : '1.4-4'}} </div>
  <div *ngIf="this.api.mapMouseLat==0" style="position:absolute;top:24px;left:6px;">Lat: ?? / Lon: ?? </div>
  <!-- NON CANCELLARE -->
  <!-- <div style="position:absolute;top:24px;left:6px;">{{this.api.mapCenterZoomString}}</div> -->
</div>


<!-- Finestra a scomparsa con dati imbarcazione -->
<div id="boatInfo" [ngStyle]="{'left.px':boatInfoX,'top.px':boatInfoY,'width.px': boatInfoWidth, 'height.px': boatInfoHeight, 'visibility':boatInfoVisibleStyle}" cdkDrag>
<!-- <div id="boatInfo" [ngStyle]="{'left.px':600,'top.px':600,'width.px': 220, 'height.px': 200, 'visibility':visible}"> -->
  
  <div id="boatInfo-handle" cdkDragHandle>
    <svg width="20px" fill="currentColor" viewBox="0 0 24 24">
      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  </div>  

  <!-- <div style="height:16px" [ngStyle]="{'background-color': boatInfo.iconColor}"></div> -->
  <!-- <div style="height:16px" [ngStyle]="{'background-color': boatInfo.iconColor, 'color':white }"><strong>{{boatInfo.name | slice:0:20}} ({{boatInfo.class}})</strong></div> -->
  <div style="height:18px; text-align: center; padding-top:4px" [ngStyle]="{'background-color': boatInfo.iconColor, 'color': boatInfo.iconColorInverted}">
    <strong>{{boatInfo.name | slice:0:20}} ({{boatInfo.class}})</strong>
  </div>
  
  <!-- <div *ngIf="boatInfo.nav_status!=50 && boatInfo.nav_status!=100" style="padding-top:3px"> -->
  <div *ngIf="boatInfo.nav_status==0" style="padding-top:3px">
    Sailnumber : {{boatInfo.sailn}} <br>
    Owner: {{boatInfo.owner | slice:0:20}} <br>
    Tracking device: {{boatInfo.dev_name}} <br>
    Status: not started <br>
    Last position at: {{boatInfo.last_msg_datetime}} <br>
    Speed 1h (sog): {{boatInfo.sog | number:'1.1-2'}} Knots<br>
    Speed 1h (vmg): -- <br>
    Distance to finish: -- <br>
    Estimated to finish:  --<br>
    Time of arrival: --<br>
    Handicap (TCC): {{boatInfo.tcc}} <br>
    {{this.api.boatLeaderBoardOrderTypeText}} : {{this.boatInfo.orderId}}
  </div>  
  <div *ngIf="boatInfo.nav_status==10 || boatInfo.nav_status==20" style="padding-top:3px">
    Sailnumber : {{boatInfo.sailn}} <br>
    Owner: {{boatInfo.owner | slice:0:20}} <br>
    Tracking device: {{boatInfo.dev_name}} <br>
    Status: <span style="color:red;">DNF</span> <br>
    Last position at: {{boatInfo.last_msg_datetime}} <br>
    Speed 1h (sog): {{boatInfo.sog | number:'1.1-2'}} Knots<br>
    Speed 1h (vmg): -- <br>
    Distance to finish: -- <br>
    Estimated to finish:  --<br>
    Time of arrival: --<br>
    Handicap (TCC): {{boatInfo.tcc}} <br>
    {{this.api.boatLeaderBoardOrderTypeText}} : {{this.boatInfo.orderId}}
  </div>  
  <div *ngIf="boatInfo.nav_status==50" style="padding-top:3px">
    Sailnumber : {{boatInfo.sailn}} <br>
    Owner: {{boatInfo.owner | slice:0:20}} <br>
    Tracking device: {{boatInfo.dev_name}} <br>
    Status: heading to {{boatInfo.nav_next_wp_name}} <br>
    Last position at: {{boatInfo.last_msg_datetime}} <br>
    Speed 1h (sog): {{boatInfo.sog | number:'1.1-2'}} Knots<br>
    Speed 1h (vmg): {{boatInfo.vmg | number:'1.1-2'}} Knots<br>
    Distance to finish: {{boatInfo.nav_dtg_tot | number:'1.1-1'}} NM<br>
    Estimated to finish: {{boatInfo.nav_ttg_tot_text}}<br>
    Estimated arrival at: {{boatInfo.nav_eta_text}} <br>
    Handicap (TCC): {{boatInfo.tcc}} <br>
    {{this.api.boatLeaderBoardOrderTypeText}} : {{this.boatInfo.orderId}}
  </div>  
  <div *ngIf="boatInfo.nav_status==100" style="padding-top:3px">
    Sailnumber : {{boatInfo.sailn}} <br>
    Owner: {{boatInfo.owner | slice:0:20}} <br>
    Tracking device: {{boatInfo.dev_name}} <br>
    Status: <span style="color:green;">arrived</span> <br>
    Last position at: {{boatInfo.last_msg_datetime}} <br>
    Speed 1h (sog): {{boatInfo.sog | number:'1.1-2'}} Knots<br>
    Speed 1h (vmg): -- <br>
    Distance to finish: -- <br>
    Estimated to finish:  --<br>
    Time of arrival: {{boatInfo.nav_toa_text}}<br>
    Handicap (TCC): {{boatInfo.tcc}} <br>
    {{this.api.boatLeaderBoardOrderTypeText}} : {{this.boatInfo.orderId}}
  </div>  

</div>
